/**
 *
 * SchoolRole
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Breadcrumbs from 'components/layout/Breadcrumbs/index.jsx';
import Spinner from 'components/Spinner/index.jsx';
import { useApi2call } from 'containers/Api2/index.js';
import ExplicitRemoveModal from 'components/interaction/ExplicitRemoveModal/index.jsx';
import { intlTags } from 'utils/intlFunctions.jsx';
import messages from './messages.js';
import RoleHeader from './RoleHeader.jsx';
import useSchoolRole from './useSchoolRole.js';
import RoleMembers from './RoleMembers.jsx';
import RoleSettings from './RoleSettings.jsx';
import { INBOX_ACTIVE } from '../InboxStatus.jsx';

function SchoolRole(props) {
  const { setMeta } = props;
  const { id } = useParams();
  const parentLink = '/admin/users#role';
  const { schoolRole, handleChange, addMembers, deleteMember, changeConversations } = useSchoolRole(id);
  const [show, setShow] = useState(false);
  const api2call = useApi2call();
  const navigate = useNavigate();
  const url = `sa/schoolroles/${id}`;
  const confirmRemoveText = { ...messages.confirmRemoveRole, values: schoolRole };

  const handleDelete = async () => {
    await api2call({
      method: 'DELETE',
      url,
      version: 2,
      success: messages.roleDeleted,
    });
    navigate(parts[0].href);
  };

  const parts = [
    { href: parentLink, label: messages.users },
    { label: schoolRole.displayName },
  ];
  const marginClasses = 'ms-sm-3 mt-3 mt-sm-0';
  const canDelete = !schoolRole.systemType;
  const header = (
    <div className="d-flex align-items-baseline justify-content-between flex-wrap flex-sm-nowrap flex">
      <Breadcrumbs parts={parts} className="flex-grow-1 card-title" />
      {canDelete && (
        <Button
          variant="light text-danger"
          icon="ss-trash"
          onClick={() => setShow(true)}
          className={marginClasses}
        >
          <FormattedMessage {...messages.removeRole} />
        </Button>
      )}
    </div>
  );
  useEffect(() => {
    setMeta({
      title: [schoolRole.displayName, messages.role],
      header,
    });
  }, [schoolRole.displayName]); // eslint-disable-line react-hooks/exhaustive-deps

  if (schoolRole.loading) {
    return <Spinner />;
  }

  return (
    <>
      <Card className="border-0 mt-4">
        <RoleHeader schoolRole={schoolRole} onChange={handleChange} />
        <RoleMembers schoolRole={schoolRole} addMembers={addMembers} deleteMember={deleteMember} />
      </Card>
      <RoleSettings schoolRole={schoolRole} onChange={changeConversations} />
      <ExplicitRemoveModal
        show={show}
        title={confirmRemoveText}
        onHide={() => setShow(false)}
        onSubmit={handleDelete}
      >
        <p><FormattedMessage {...messages.removeRoleModal1} values={schoolRole} /></p>
        {schoolRole.conversations.inbox === INBOX_ACTIVE && (
          <>
            <FormattedMessage {...messages.removeRoleModal2} />
            <FormattedMessage {...messages.archivedInboxRules} values={{ ...schoolRole, ...intlTags(['li', 'ul']) }} />
          </>
        )}
      </ExplicitRemoveModal>
    </>
  );
}

SchoolRole.propTypes = {
  setMeta: PropTypes.func,
};

export default SchoolRole;
